import { Injectable, EventEmitter } from '@angular/core';    
import { Subscription } from 'rxjs/internal/Subscription';    
    
@Injectable({    
  providedIn: 'root'    
})    
export class EventEmitterService {    
    
  invokeCount = new EventEmitter();    
  subsVar: Subscription;    
    
  constructor() { }    
    
  updateCount() {    
    this.invokeCount.emit();    
  }    
}    
